import { ProfileEntity } from "./profile-entity";

export class Profile {
  public id: number;
  public profile: ProfileEntity;
}